import React, { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import IconMC from '../../../components/IconMC';
import { getScoreColor, getScoreBgColor, getTemperatureKey, getTemperatureLevelFromScore } from '../utils/leadScoreUtils';

const LeadScoreBadgeMC = memo(({ leadScore }) => {
  const { t } = useTranslation('InboxMC');

  const scoreValue = leadScore?.lead_score;
  const alert = leadScore?.alert;

  const temperatureLabel = useMemo(() => {
    if (scoreValue == null) return null;
    const level = getTemperatureLevelFromScore(scoreValue);
    const key = getTemperatureKey(level);
    return key ? t(key) : null;
  }, [scoreValue, t]);

  const displayScore = scoreValue ?? 0;

  return (
    <div className="tw-flex tw-gap-1.5 tw-items-center tw-mt-1">
      <div className={`tw-flex tw-items-center tw-gap-1 tw-px-1.5 tw-py-0.5 tw-rounded ${getScoreBgColor(displayScore, 50)}`}>
        <span className={`tw-text-xs tw-font-semibold ${getScoreColor(displayScore)}`}>
          {displayScore}
        </span>
      </div>
      {temperatureLabel && (
        <span className="tw-text-xs tw-text-gray-500">
          {temperatureLabel}
        </span>
      )}
      {alert && (
        <IconMC name="warning" size="sm" className="tw-text-orange-500" />
      )}
    </div>
  );
});

LeadScoreBadgeMC.displayName = 'LeadScoreBadgeMC';

export default LeadScoreBadgeMC;
